/*
 Forgot-password component
 url match: /forgot-password
 Displays email
 with Send password reset email button
*/
import { withRouter, Link } from 'react-router-dom';
import React from 'react';
import { inject, observer } from 'mobx-react';
//import { isObjectEmpty } from '../../utils';
import TextField from '@material-ui/core/TextField';
import Button from '@material-ui/core/Button';
import { withStyles } from '@material-ui/core/styles';
import { loginStyles } from '../../Styles/loginStyles';
import FormControl from '@material-ui/core/FormControl';
import FormHelperText from '@material-ui/core/FormHelperText';
import { ReactSVG } from 'react-svg'
import Images from '../../Theme/Images';
import Loader from 'react-loader-spinner'
import InputAdornment from '@material-ui/core/InputAdornment';
import BackgroundImage from '../../Common/BackgroundImage';
 
@inject('userStore')
@observer
class Register extends React.Component {

  state = {
    user: {
      email: "",
      userFullName: "",
      password1: "",
      password2: "",
      userType: "ADMIN",
    },
    validationErrors: {},
    registrationSuccessful: false,
    showPassword1: false,
    showPassword2: false,
  }

  componentDidMount() {
    if (this.props.userStore.token)
      this.props.history.push("/dashboard/drafts")
  }

  handleChange = (field, value) => {
    const user = Object.assign({}, this.state.user, {
      [field]: value
    });
    this.setState({ user });
  }

  register = (e) => {
    e.preventDefault();
    const { user } = this.state;
    let valid = false;
    valid = this.validateFields()
    if (valid) {
      let newUser = {
        email: user.email,
        userFullName: user.userFullName,
        password: user.password1,
        enterpriseAddress: user.enterpriseAddress,
        enterpriseName: user.enterpriseName,
        department: user.department,
        domain: user.domain
      }
      this.props.userStore.register(newUser)
        .then(() => {
          if (!this.props.userStore.registerFailed)
            this.setState({
              registrationSuccessful: true
            })
        })
    }
  }

  validateFields() {
    const { user, validationErrors } = this.state;
    const { userStore } = this.props
    let valid = true;
    if (!userStore.validateEmail(user.email)) {
      validationErrors['email'] = "Please enter a valid email address";
      this.setState({ validationErrors });
      valid = false;
    }
    else
      delete validationErrors['email']
    if (!user.password1 || user.password1.length < 6 || user.password1.length > 25) {
      validationErrors['password1'] = "Please enter a valid password with min. 6 and max. 25 characters";
      this.setState({ validationErrors });
      valid = false;
    }
    else
      delete validationErrors['password1']
    if (!user.password2 || user.password2.length < 6 || user.password2.length > 25) {
      validationErrors['password2'] = "Please enter a valid password with min. 6 and max. 25 characters";
      this.setState({ validationErrors });
      valid = false;
    }
    else
      delete validationErrors['password2']
    if (!user.userFullName || user.userFullName.length < 3 || user.userFullName.length > 40 || !user.userFullName.replace(/\s/g, '').length) {
      validationErrors['userFullName'] = "Name must contain a minimum of 3 and maximum of 40 characters ";
      this.setState({ validationErrors });
      valid = false;
    }
    else
      delete validationErrors['userFullName']
    if (!user.enterpriseName || user.enterpriseName.length < 3 || user.enterpriseName.length > 40 || !user.enterpriseName.replace(/\s/g, '').length) {
      validationErrors['enterpriseName'] = "Enterprise name must contain a minimum of 3 and maximum of 40 characters ";
      this.setState({ validationErrors });
      valid = false;
    }
    else
      delete validationErrors['enterpriseName']
    if (!user.domain || user.domain.length < 3 || user.domain.length > 40 || !user.domain.replace(/\s/g, '').length) {
      validationErrors['domain'] = "Enterprise domain must contain a minimum of 3 and maximum of 40 characters ";
      this.setState({ validationErrors });
      valid = false;
    }
    else
      delete validationErrors['domain']
    if (!user.enterpriseAddress || user.enterpriseAddress.length < 3 || user.enterpriseAddress.length > 40 || !user.enterpriseAddress.replace(/\s/g, '').length) {
      validationErrors['enterpriseAddress'] = "Enterprise address must contain a minimum of 3 and maximum of 40 characters ";
      this.setState({ validationErrors });
      valid = false;
    }
    else
      delete validationErrors['enterpriseAddress']
    if (user.password1 !== user.password2) {
      validationErrors['passwordMatch'] = "Passwords do not match!";
      this.setState({ validationErrors });
      valid = false;
    }
    else
      delete validationErrors['passwordMatch']
    if (valid) {
      this.setState({
        validationErrors: {}
      });
    }
    return valid;
  }
  render() {
    const { inProgress, registerFailed, statusText } = this.props.userStore;
    const { classes } = this.props;
    const { user, validationErrors, registrationSuccessful, showPassword1, showPassword2 } = this.state;
    return (
      <div className={classes.rowFlex} style={{overflowY: 'hidden'}}>
        <div style={{ width: '50%' }}>
          <BackgroundImage/>
        </div>
        <div className={classes.registerContainer}>
          <Link to="/">
            <ReactSVG
              beforeInjection={svg => {
                svg.classList.add(classes.svg)
              }}
              src={Images.logo} />
          </Link>
          {
            registrationSuccessful ?
              <p style={{ color: this.props.theme.palette.white, padding: '1vw' }}>A verification link has been sent to your
          email account. Please click on the link in the mail to complete the registration process.</p> :
              <div><p style={{ textAlign: 'center', color: 'white' }}>Register Form</p>
                <form noValidate autoComplete="off" className={classes.formStyle}>
                  <FormControl error aria-describedby="component-error-text" className={classes.formControl}>
                    <TextField
                      required
                      id="name-input"
                      placeholder="Full Name*"
                      type="text"
                      name="name"
                      autoComplete="name"
                      margin="normal"
                      variant="filled"
                      fullWidth
                      InputProps={{
                        disableUnderline: true,
                        classes: {
                          input: classes.textFieldInput,
                        },
                      }}
                      value={user.userFullName}
                      onChange={(event) => this.handleChange("userFullName", event.target.value)}
                    />
                    {validationErrors.userFullName && <FormHelperText style={{ display: 'flex' }} id="name-input">
                      <ReactSVG
                        beforeInjection={svg => {
                          svg.classList.add(classes.svg)
                        }}
                        src={Images.error} />{validationErrors.userFullName}</FormHelperText>}
                    <TextField
                      required
                      id="email-input"
                      placeholder="Email*"
                      type="email"
                      name="email"
                      autoComplete="email"
                      margin="normal"
                      variant="filled"
                      fullWidth
                      InputProps={{
                        disableUnderline: true,
                        classes: {
                          input: classes.textFieldInput,
                        },
                      }}
                      value={user.email}
                      onChange={(event) => this.handleChange("email", event.target.value)}
                    />
                    {validationErrors.email && <FormHelperText style={{ display: 'flex' }} id="email-input">
                      <ReactSVG
                        beforeInjection={svg => {
                          svg.classList.add(classes.svg)
                        }}
                        src={Images.error} />
                      {validationErrors.email}</FormHelperText>}
                    <TextField
                      required
                      id="e-name-input"
                      placeholder="Enterprise Name*"
                      type="text"
                      name="name"
                      autoComplete="entname"
                      margin="normal"
                      variant="filled"
                      fullWidth
                      InputProps={{
                        disableUnderline: true,
                        classes: {
                          input: classes.textFieldInput,
                        },
                      }}
                      value={user.enterpriseName}
                      onChange={(event) => this.handleChange("enterpriseName", event.target.value)}
                    />
                    {validationErrors.enterpriseName && <FormHelperText style={{ display: 'flex' }} id="name-input">
                      <ReactSVG
                        beforeInjection={svg => {
                          svg.classList.add(classes.svg)
                        }}
                        src={Images.error} />
                      {validationErrors.enterpriseName}</FormHelperText>}
                    <TextField
                      required
                      id="enterpriseAddress-input"
                      placeholder="Enterprise Address*"
                      type="text"
                      name="name"
                      autoComplete="enterpriseAddress"
                      margin="normal"
                      variant="filled"
                      fullWidth
                      InputProps={{
                        disableUnderline: true,
                        classes: {
                          input: classes.textFieldInput,
                        },
                      }}
                      value={user.enterpriseAddress}
                      onChange={(event) => this.handleChange("enterpriseAddress", event.target.value)}
                    />
                    {validationErrors.enterpriseAddress && <FormHelperText style={{ display: 'flex' }} id="name-input">
                      <ReactSVG
                        beforeInjection={svg => {
                          svg.classList.add(classes.svg)
                        }}
                        src={Images.error} />
                      {validationErrors.enterpriseAddress}</FormHelperText>}
                    <TextField
                      required
                      id="department-input"
                      placeholder="Enterprise Department"
                      type="text"
                      name="name"
                      autoComplete="department"
                      margin="normal"
                      variant="filled"
                      fullWidth
                      InputProps={{
                        disableUnderline: true,
                        classes: {
                          input: classes.textFieldInput,
                        },
                      }}
                      value={user.department}
                      onChange={(event) => this.handleChange("department", event.target.value)}
                    />
                    {validationErrors.department && <FormHelperText style={{ display: 'flex' }} id="name-input">
                      <ReactSVG
                        beforeInjection={svg => {
                          svg.classList.add(classes.svg)
                        }}
                        src={Images.error} />
                      {validationErrors.department}</FormHelperText>}
                    <TextField
                      required
                      id="department-input"
                      placeholder="Domain"
                      type="text"
                      name="domain"
                      autoComplete="domain"
                      margin="normal"
                      variant="filled"
                      fullWidth
                      InputProps={{
                        disableUnderline: true,
                        classes: {
                          input: classes.textFieldInput,
                        },
                      }}
                      value={user.domain}
                      onChange={(event) => this.handleChange("domain", event.target.value)}
                    />
                    {validationErrors.domain && <FormHelperText style={{ display: 'flex' }} id="name-input">
                      <ReactSVG
                        beforeInjection={svg => {
                          svg.classList.add(classes.svg)
                        }}
                        src={Images.error} />
                      {validationErrors.domain}</FormHelperText>}

                    <TextField
                      required
                      id="password1-input"
                      placeholder="Set Password*"
                      type={showPassword1 ? 'text' : 'password'} name="password1"
                      name="password1"
                      margin="normal"
                      variant="filled"
                      fullWidth
                      InputProps={{
                        disableUnderline: true,
                        classes: {
                          input: classes.textFieldInput,
                        },
                        endAdornment: <InputAdornment position="end" >
                          {!showPassword1 ? <ReactSVG src={Images.visibilityIcon} className={classes.showPassword} onClick={(e) => this.setState({ showPassword1: true })} /> :
                            <ReactSVG src={Images.visibilityOffIcon} className={classes.showPassword} onClick={(e) => this.setState({ showPassword1: false })} />}
                        </InputAdornment>
                      }}
                      value={user.password1}
                      onChange={(event) => this.handleChange("password1", event.target.value)}
                    />
                    {validationErrors.password1 && <FormHelperText style={{ display: 'flex' }} id="email-input">
                      <ReactSVG
                        beforeInjection={svg => {
                          svg.classList.add(classes.svg)
                        }}
                        src={Images.error} />
                      {validationErrors.password1}</FormHelperText>}
                    <TextField
                      required
                      id="password2-input"
                      placeholder="Re-enter Password*"
                      type={showPassword2 ? 'text' : 'password'} name="password"
                      name="password2"
                      margin="normal"
                      variant="filled"
                      fullWidth
                      InputProps={{
                        disableUnderline: true,
                        classes: {
                          input: classes.textFieldInput,
                        },
                        endAdornment: <InputAdornment position="end" >
                          {!showPassword2 ? <ReactSVG src={Images.visibilityIcon} className={classes.showPassword} onClick={(e) => this.setState({ showPassword2: true })} /> :
                            <ReactSVG src={Images.visibilityOffIcon} className={classes.showPassword} onClick={(e) => this.setState({ showPassword2: false })} />}
                        </InputAdornment>
                      }}
                      value={user.password2}
                      onChange={(event) => this.handleChange("password2", event.target.value)}
                    />
                    {validationErrors.password2 && <FormHelperText style={{ display: 'flex' }} id="email-input">
                      <ReactSVG
                        beforeInjection={svg => {
                          svg.classList.add(classes.svg)
                        }}
                        src={Images.error} />
                      {validationErrors.password2}</FormHelperText>}
                    {!validationErrors.password1 && !validationErrors.password2 && validationErrors.passwordMatch && <FormHelperText style={{ display: 'flex' }} id="passwordMatch-input">
                      <ReactSVG
                        beforeInjection={svg => {
                          svg.classList.add(classes.svg)
                        }}
                        src={Images.error} />
                      {validationErrors.passwordMatch}</FormHelperText>}

                  </FormControl>
                  {/*this.state.errorMessage && <p className={classes.errorStyle}>{this.state.errorMessage}</p> */}
                  {
                    inProgress ? <Button variant="contained" className={classes.button} fullWidth>
                      <Loader height={30} width={30} color={this.props.theme.palette.white} />
                    </Button> :
                      <Button variant="contained" className={classes.button} type="submit" onClick={this.register} fullWidth>
                        Register
                </Button>
                  }
                  {/*registerFailed && <p className={classes.errorStyle}>{statusText}</p>*/}
                </form>
              </div>
          }
        </div>
      </div>
    );
  }
}
export default withStyles(loginStyles, { withTheme: true })(withRouter(Register));
